import React from "react";

import Navbar from "../components/Navbar";
import Contact from "../components/ContactUs/Contact";

const ContactPage = () => {
  return (
    <>
      <Navbar />
      <Contact />
     
    </>
  );
};

export default ContactPage;
